<template>
  <formulario :datos="data"></formulario>
</template>

<script>
import Formulario from "./Registro-newUser";
export default {
  name: "Registro",
  components: {
    Formulario
  },
  data() {
    return {
      id: 0
    };
  },
  created() {
    this.setPreReg();
  },
  computed: {
    token() {
      return JSON.parse(window.atob(this.$route.params.token)) || false;
    },
    data() {
      let result = false;
      if (this.token) {
        result = this.$store.getters.getUserPreRegisterData(this.token);
      }
      return result;
    }
  },
  methods: {
    setPreReg() {
      this.$store.dispatch("setUsersPreReg");
    }
  }
};
</script>
